import React from "react";
import PropTypes from "prop-types";
import classes from "./MapPin.module.css";
import Fonts from "../assets/Fonts";
import Colors from "../assets/Colors";

export const MapPin = ({ value, color, bgColor, onClick }) => {
  return (
    <>
      <style jsx>{`
        .${classes.mapPin} {
          background-color: ${bgColor};
        }
        .${classes.mapPinText} {
          color: ${color};
        }
      `}</style>
      <div className={`${classes.mapPin}`} onClick={onClick}>
        <span className={`${classes.mapPinText}`} style={{ ...Fonts.h9 }}>
          {value}
        </span>
        <div
          className={classes.arrowDown}
          style={{ backgroundColor: Colors.neutralShadesOfNero }}
        />
      </div>
    </>
  );
};

MapPin.propType = {
  value: PropTypes.number,
  color: PropTypes.string,
  bgColor: PropTypes.string,
};

MapPin.defaultProps = {
  value: 3,
  color: Colors.white,
  bgColor: Colors.neutralShadesOfNero,
};
